// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"89cea181","48":"4e49e503","120":"df90296c","124":"e671f985","132":"31d6cfe0","628":"82fedf87","760":"7d168e1a","872":"89cea181","956":"05e2e530","960":"630c55dd"}[chunkId] + ".chunk.css";
};